module.exports = __webpack_public_path__ + "img/c3c0b4b.jpg";